import { Component, OnInit } from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';

@Component({
  selector: 'app-left-menu',
  templateUrl: './left-menu.component.html',
  styleUrls: ['./left-menu.component.scss']
})
export class LeftMenuComponent implements OnInit {
  currentPath: String;
  constructor(private router: Router ) {
    router.events.subscribe((val) => {

        if (val instanceof NavigationEnd) {
          this.currentPath = val.urlAfterRedirects;
        }
      }
    ) ;

  }

  ngOnInit(): void {
    this.currentPath = this.router.url ;
  }

}
